export const splitText = (value: string) => {
  return value.split('.').join('.<br/>');
};
